export type UserRole = 'broker' | 'carrier' | 'service_provider';

export interface AuthUser {
  name:  string;
  email: string;
  role:  UserRole;
}

export function useAuth(): { user: AuthUser | null; isAuthenticated: boolean } {
  const raw = localStorage.getItem('auth_user');
  if (!raw) return { user: null, isAuthenticated: false };

  try {
    const user = JSON.parse(raw) as AuthUser;
    return { user, isAuthenticated: true };
  } catch {
    return { user: null, isAuthenticated: false };
  }
}

export function logout() {
  localStorage.removeItem('auth_user');
  window.location.href = '/login';
}
